import { Dialog, DialogContent } from '@mui/material';
import { MprcDialogTitleClose } from 'components';
import { MeetingType } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MeetingContent } from 'views/lms/student/EnrollmentView/Course/ContentComponents/meeting/MeetingContent';

interface IProps {
    componentId: string;
    versionNumber?: number;
    classroomId?: string | null;
    meetingType: MeetingType;
    open: boolean;
    onClose: () => void;
}

export const MeetingViewer: React.FC<IProps> = ({ componentId, versionNumber, classroomId, open, meetingType, onClose }) => {
    const { t } = useTranslation("lms");
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            onClose={onClose}
        >
            <MprcDialogTitleClose
                title={t(meetingType == MeetingType.Presential ? "Meeting.Common.PresentialTitle" : "Meeting.Common.OnlineTitle")}
                shrinkPadding
                onClose={onClose} />
            <DialogContent sx={{ p: 1.5 }}>
                <MeetingContent
                    componentId={componentId}
                    classroomId={classroomId}
                    versionNumber={versionNumber}
                />
            </DialogContent>
        </Dialog>
    );
};
